export default "__VITE_ASSET__CZtrMaeJ__"